<template>
  <div class="tile">
    <div class="container">
      <div v-for="grouped in groupedAccounts" :key="grouped._id" class="tile is-ancestor">
        <div v-for="(account , index) in grouped.accounts" :key="index" class="tile is-parent is-4">
          <article v-if="account._id" class="tile is-child box">
            <nav class="level is-mobile">
              <div class="level-left" @click="editConta(account)">
                <b-icon icon="pencil-outline"></b-icon>
              </div>
              <div class="level-right">
                <div class="field">
                  <b-switch
                    v-model="account.isActive"
                    type="is-success"
                    :disabled="account.isDefault"
                  >{{account.isActive ? 'Ativa': 'Inativa'}}</b-switch>
                </div>
              </div>
            </nav>
            <div>
              <p class="title">{{account.nome}}</p>
              <p class="subtitle">Saldo: R$ {{account.saldo}}</p>
              <p class="subtitle">Saldo Inicial: R$ {{account.saldo_inicial}}</p>
            </div>
          </article>

          <article v-else class="tile is-child box tile-add-conta pontilhado">
            <div class="block has-text-centered" @click="addConta">
              <b-icon icon="plus" size="is-large" type="is-success"></b-icon>
              <p class="title">Adicionar Conta</p>
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddConta from "./components/AddConta";
import EditConta from "./components/EditConta";

export default {
  data() {
    return {
      maxAccounts: 6,
      numberOfGroups: 2
    };
  },
  computed: {
    // Isso precisa ser melhorado... Estou criando grupos para serem renderizados adequadamente com um v-for
    groupedAccounts() {
      let accounts = this.$store.getters["contas/getContas"] || [];
      let groupAccount = [];

      for (let i = 0; accounts.length < this.maxAccounts; i++) {
        accounts.push({ _id: null });
      }

      for (let i = 0; i < this.numberOfGroups; i++) {
        groupAccount.push({
          _id: `account_${i}`,
          accounts: accounts.splice(0, 3)
        });
      }
      return groupAccount;
    }
  },
  methods: {
    addConta() {
      this.$modal.open({
        parent: this,
        component: AddConta,
        hasModalCard: true
      });
    },
    editConta(conta) {
      this.$modal.open({
        parent: this,
        component: EditConta,
        hasModalCard: true,
        props: {
          account: conta
        }
      });
    }
  },
  mounted() {
    this.$store.dispatch("contas/getContasInFirestore");
  }
};
</script>

<style>
.tile-add-conta {
  display: flex;
  justify-content: center;
  align-items: center;
}
.pontilhado{
  border: 2px dotted #999;
  min-height: 188px;
}
</style>
